module.exports = __webpack_public_path__ + "media/images/background/user-bg-b23526d1875551daea50bcb943933316.jpg";